import React from "react";
import { motion } from "framer-motion";

/** Scroll-reveal wrapper. */
export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/** Masked line-by-line reveal for large headlines. */
export function MaskedLines({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.1 }) {
  return (
    <span className={className}>
      <span className="sr-only">{lines.join(" ")}</span>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.15em]" aria-hidden="true">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
            {i < lines.length - 1 ? " " : ""}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
